import LanguageEntry from "./LanguageEntry";
import { getURLParameter } from '../../../../../lib/html5-software-library/src/ranj/util/URLUtil';

export default class LanguageModel {
    constructor() {
        this._currentLanguageId = "en-us";
        this._availableLanguages = [];
    }

    set currentLanguage(id) {
        this._currentLanguageId = id;
    }

    get currentLanguage() {
        return this._currentLanguageId;
    }

    get availableLanguages() {
        return this._availableLanguages;
    }

    get defaultLanguage() {
        return this._defaultLanguage;
    }

    /**
     * 
     * @param {{ languages: Array<{ id: string, label: string }> }} languagesObj 
     */
    setPropertiesFromObject(languagesObj) {
        this._availableLanguages = languagesObj.languages.map(l => new LanguageEntry(l.id, l.label));
        this._defaultLanguage = languagesObj.defaultLanguage;
        this._currentLanguageId = this._availableLanguages.find(l => l.id === this._defaultLanguage).id;
    }
}